module.exports = __webpack_public_path__ + "img/user_bg.9221bbaf.png";